/** Compare calendar dates in dispatch's Central time zone, independent of browser zone. */
function dateKey(value?: string): string | null {
  const raw = value?.trim() || '';
  const iso = /^(\d{4})-(\d{2})-(\d{2})(?:[ T].*)?$/.exec(raw);
  const mdy = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(raw);
  if (!iso && !mdy) return null;
  const [year, month, day] = iso
    ? [Number(iso[1]), Number(iso[2]), Number(iso[3])]
    : [Number(mdy![3]), Number(mdy![1]), Number(mdy![2])];
  const date = new Date(Date.UTC(year, month - 1, day));
  if (year < 1000 || date.getUTCFullYear() !== year || date.getUTCMonth() + 1 !== month || date.getUTCDate() !== day) return null;
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function redeliveryExpirationWarning(
  order: { offhire?: string; redeliveryExpirationDate?: string },
  dispatchGroupLegs?: { isTerminate?: boolean | number; legAction2?: string | null; legtype?: string | null }[],
  today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()),
): string | null {
  if (order.offhire !== 'Y') return null;
  const expires = dateKey(order.redeliveryExpirationDate);
  if (!expires || expires >= today) return null;
  if (!dispatchGroupLegs?.some((leg) => leg.isTerminate || leg.legAction2 === 'TERMINATE')) return null;
  return `Warning: Redelivery Expiration (${order.redeliveryExpirationDate}) has passed for this off-hire return.`;
}
